import { DataInStatsModel } from '@/models/data-lake/data-lake';
import { dataLakeAPI } from '@/providers/apis/data-lake/data-lake';
import moment from 'moment';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'tool-data-pullup',
})

export default class TooldataPullupComponent extends Vue {

    // ----------------------------------------------------------
    // Properties

    @Prop()
    private selectedTool!: DataInStatsModel;

    @Prop()
    private activeRange!: any;

    private currentPage: number = 1;

    private perPage: number = 10;

    private toolFileList: any = [];

    private totalCounts: number = 20;

    private isLoading: boolean = false;

    private toolFields: any = [
        {
            label: 'S.No',
            key: 'index',
        },
        {
            label: 'File Name',
            key: 'fileName',
        },
        {
            label: 'Created At',
            key: 'createdAt',
        },
        {
            label: 'Volume',
            key: 'volume',
        },
    ];



    // ----------------------------------------------------------
    // Hooks

    private created() {
        this.loadData();
    }


    // ----------------------------------------------------------
    // Actions

    private onSelectPage(pageNumber: number) {
        this.currentPage = pageNumber;
        let limit = this.perPage * pageNumber;
        if (limit > this.totalCounts) {
            limit = this.totalCounts;
        }
        if (limit > this.toolFileList.length) {
            this.loadData();
        }
    }

    // ----------------------------------------------------------
    // Methods

    private loadData() {
        this.isLoading = true;
        const selectedTool = this.selectedTool;
        const activeRange = this.activeRange;
        const providerType = selectedTool.isPublisher ? 'content-provider' : 'tool-provider';
        const perPage = this.perPage;
        const currentPage = this.currentPage;
        const params: any = {
            id: selectedTool.id,
            limit: (perPage * currentPage) - this.toolFileList.length,
            offset: this.toolFileList.length,
        };
        if (activeRange.key !== 'till-now') {
            params.startDate = activeRange.startDate;
            params.endDate = activeRange.endDate;
        }
        dataLakeAPI.fetchFilesByToolId(providerType, params).then((dataList) => {
            this.toolFileList = this.toolFileList.concat(dataList.datalakeDataInStats);
            this.totalCounts = dataList.totalCounts;
            this.isLoading = false;
        });
    }


}
